
<div>
  <mat-tab-group color="primary" (selectedTabChange)='selectionChange($event)'>
    <mat-tab label="Personal Info">
      <div>
          <button mat-raised-button color='accent' (click)='updatePlayer()' style='margin-top:10px' [disabled]='!isDirty()'>
            Save
            <i class='fa fa-spin fa-spinner' *ngIf='saving'></i>
          </button>
      </div>
      <div fxLayout.xs='row wrap' style='margin-top:10px' fxLayoutAlign='start stretch'>
        <mat-card>
          <mat-card-title>Profile</mat-card-title>
          <mat-card-content>
            <mat-form-field>
              <mat-label>First Name</mat-label>
              <input matInput placeholder='First Name' [(ngModel)]='player.first'>
            </mat-form-field>
            <mat-form-field>
              <mat-label>Last Name</mat-label>
              <input matInput placeholder='Last Name' [(ngModel)]='player.last'>
            </mat-form-field>
            <mat-form-field>
              <mat-label>Handicap Id</mat-label>
              <input matInput placeholder='Handicap Id' [(ngModel)]='player.usga_id'>
            </mat-form-field>
            <mat-form-field>
              <mat-label>Index</mat-label>
              <input matInput placeholder='Index' [(ngModel)]='player.handicap' disabled>
            </mat-form-field>
            <mat-form-field>
              <mat-label>eMail</mat-label>
              <input matInput placeholder='eMail' [(ngModel)]='player.email'>
            </mat-form-field>
            <mat-form-field>
              <mat-label>Password</mat-label>
              <input matInput type='password' placeholder='Password' [(ngModel)]='player.password'>
            </mat-form-field>
          </mat-card-content>
        </mat-card>
        <mat-card>
          <mat-card-title>Location</mat-card-title>
          <mat-card-content>
            <mat-form-field>
              <mat-label>Address</mat-label>
              <input matInput placeholder='Address' [(ngModel)]='player.address'>
            </mat-form-field>
            <mat-form-field>
              <mat-label>City</mat-label>
              <input matInput placeholder='City' [(ngModel)]='player.city'>
            </mat-form-field>
            <mat-form-field>
              <mat-label>zip</mat-label>
              <input matInput placeholder='zip' [(ngModel)]='player.zipcode'>
            </mat-form-field>
            <mat-form-field>
              <mat-label>State</mat-label>
              <mat-select placeholder="State" [(ngModel)]="player.state" (selectionChange)='getCourses()'>
                <mat-option *ngFor="let state of allStates" [value]='state.state'>
                  {{ state.state }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field>
              <mat-label>Home Course</mat-label>
              <mat-select placeholder="Home Course" [(ngModel)]="player.home_course">
                <mat-option *ngFor="let course of courses" [value]='course.course_id'>
                  {{ course.coursename }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </mat-card-content>
        </mat-card>
        <mat-card *ngIf='optInOptions'>
          <mat-card-title>Opt-in Options</mat-card-title>
          <div fxLayout='row'>
            <div fxFlex='1 1 60%'>
              <label>
                Index Revision
              </label>
            </div>
            <div fxFlex='1 1 40%'>
              <mat-slide-toggle [checked]="+optInOptions.index_revision === 1" (change)="toggleOption('index_revision')"></mat-slide-toggle>
            </div>
          </div>
          <div fxLayout='row'>
            <div fxFlex='1 1 60%'>
              <label>
                Group Notifications
              </label>
            </div>
            <div fxFlex='1 1 40%'>
              <mat-slide-toggle [checked]="+optInOptions.group_notifications === 1" (change)="toggleOption('group_notifications')"></mat-slide-toggle>
            </div>
          </div>
          <div fxLayout='row'>
            <div fxFlex='1 1 60%'>
              <label>
                Event Notifications
              </label>
            </div>
            <div fxFlex='1 1 40%'>
              <mat-slide-toggle [checked]="+optInOptions.event_notifications === 1" (change)="toggleOption('event_notifications')"></mat-slide-toggle>
            </div>
          </div>
          <div fxLayout='row'>
            <div fxFlex='1 1 60%'>
              <label>
                Announcements
              </label>
            </div>
            <div fxFlex='1 1 40%'>
              <mat-slide-toggle [checked]="+optInOptions.ggk_announcements === 1" (change)="toggleOption('ggk_announcements')"></mat-slide-toggle>
            </div>
          </div>
        </mat-card>
      </div>
    </mat-tab>
    <mat-tab label='Handicap Rounds'>
      <div *ngIf='handicap_rounds && handicap_rounds.scores.length>0' style='padding: 20px 0 20px 0'>
      <p style='font-weight: 900'>
        Revision Rounds
      </p>
      <s18-display-round-list [rounds]='handicap_rounds.scores' [tRounds]='false'></s18-display-round-list>
    </div>
    </mat-tab>
    <mat-tab label='Subscription & Billing'>
      <s18-billing></s18-billing>
    </mat-tab>
    <mat-tab label='Member Credits'>
      <s18-player-profile-credits></s18-player-profile-credits>
    </mat-tab>
  </mat-tab-group>
</div>